import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { RodeoEventSchedule } from '../../../../model/rodeoEventSchedule';
import { RodeoEventRegistration } from '../../../../model/rodeoEventRegistration';
import { ModalController, ToastController, AlertController, LoadingController, Events, PopoverController } from 'ionic-angular';
import { AlertMessager } from '../../../../lib/alertMessager';
import { EntryService } from '../../../../services/entry.service';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';
import { PaymentService } from '../../../../services/payment.service';
import { PaymentDetailsPage } from './payment-details';
import { EntryLogsPage } from './entry-logs';
import { Organization } from '../../../../model/organization';
import { NewEntryPage } from './new-entry';
import { EventSelectPopup } from './event-select';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';
import { Horse } from '../../../../model/horse';
import { SearchComponent } from '../../../search/search.component';
import { NewMemberPage } from '../memberships/new-member';
import { HorseService } from '../../../../services/horse.service';
import { RunService } from '../../../../services/run.service';
import { RunDisplayHelper } from '../../../../lib/run-display-helper';
import { DateHelperService } from '../../../../services/date-helper';
import { ChangeRequestHelper, ChangeRequestStatus } from '../../../../model/registration-change-request';

@Component({
    selector: 'staff-entries',
    templateUrl: 'entries.html'
})
export class EntriesSection {
    _rodeo: Rodeo;
    _viewMode: string = 'overview';
    rodeoEventList: any[] = [];
    rodeoEventFilter: string = 'Any';
    schedules: any[] = [];

    searchChangeObservable;
    searchQuery: string;
    searchResults: any = [];

    entrySearchChangeObservable;
    entryResults: any = [];
    firstName: string;
    lastName: string;
    confirmation: string;
    runNumber: string;
    payConfirmation: string;
    scheduleFilter: string = 'Any';
    entryStatus: string = 'Any';

    totalEntryResults: number;

    showPrefs: boolean = false;

    _organizations: any[] = [];

    popoverActive: boolean;
    loadingData: boolean;

    perfMap: Map<number, RodeoEventSchedule> = new Map<number, RodeoEventSchedule>();

    runChangedObservable;

    exceededResults: boolean;

    nameSortAsc: boolean = true;
    nameSortDesc: boolean;
    confSortAsc: boolean;
    confSortDesc: boolean;
    positionSortAsc: boolean;
    positionSortDesc: boolean;
    entryChangeRequestDictionary: any;

    runDisplayHelper: RunDisplayHelper = RunDisplayHelper.instance();
    
    @Output() pendingRequestCountUpdated = new EventEmitter<number>();

    @Input()
    set rodeo(rodeo: Rodeo) {
        if (rodeo != null) {
            this._rodeo = rodeo;

            this.rodeoEventList = [];
            this.rodeoEventList.push({ displayName: 'Any' });

            this.schedules = [];
            this.schedules.push({ name: 'Any' });

            this._rodeo.rodeoEvents.forEach(rodeoEvent => {
                this.rodeoEventList.push(rodeoEvent);

                if (rodeoEvent.preferencesAllowed >= 1)
                    this.showPrefs = true;

                rodeoEvent.schedules.forEach(schedule => {
                    if (this.schedules.filter(x => x.name === schedule.name).length == 0)
                        this.schedules.push(schedule);
                });

                rodeoEvent.registrations.forEach((registration) => {
                    if (registration.payments) {
                        registration.payments.forEach((payment) => {
                            if (payment.transactionDate.indexOf('T') != -1)
                                payment.transactionDate = payment.transactionDate.substring(0, payment.transactionDate.indexOf('T'));
                        })
                    }
                });
            });

            this.schedules.sort((a, b) => {
                let aDate = new Date(a.scheduledDate);
                let bDate = new Date(b.scheduledDate);

                return aDate > bDate ? 1 : aDate < bDate ? -1 : 0;
            });

            this.perfMap.clear();
            this._rodeo.rodeoEvents.forEach(rodeoEvent => {
                rodeoEvent.schedules.forEach(schedule => {
                    this.perfMap.set(schedule.id, schedule);
                })
            });

            this._rodeo.rodeoEvents.flatMap(x => x.schedules).flatMap(x => x.runs).filter(x => x.round == 1).forEach((run) => {
                run.used = false;
            });

            this.rodeoEventFilter = 'Any';
            this.filterEntries();
        }
    }
    get rodeo(): Rodeo {
        return this._rodeo;
    }

    @Input()
    set viewMode(viewMode: string) {
        if (viewMode != null) {
            this._viewMode = viewMode;
            this.filterEntries();
        }
    }
    get viewMode(): string {
        return this._viewMode;
    }

    @Input()
    set organizations(organizations: Organization[]) {
        if (organizations != null) {
            this._organizations = organizations;
        }
    }
    get organizations(): Organization[] {
        return this._organizations;
    }

    constructor(private modalCtrl: ModalController, private alertController: AlertController, private alert: AlertMessager, private loadingController: LoadingController,
        private entryService: EntryService, private toast: ToastController, private popoverController: PopoverController, private paymentService: PaymentService,
        public events: Events, private horseService: HorseService, private runService: RunService, public dateHelper: DateHelperService) {
            this.events.subscribe('RegistrationAdded', (data) => this.registrationAdded(data));
            this.events.subscribe('RegistrationUpdated', (data) => this.registrationUpdated(data));
            this.events.subscribe('RegistrationDeleted', (data) => this.registrationDeleted(data));
            this.events.subscribe('RunAdded', (data) => this.filterEntries());
            this.events.subscribe('RunUpdated', (data) => this.filterEntries());
            this.events.subscribe('RunDeleted', (data) => this.filterEntries());
    }

    registrationAdded(registrations) {
        this.filterEntries();
    }

    registrationUpdated(registrations) {
        registrations.forEach((registration) => {
            for (let i = 0; i < this.entryResults.length; i++) {
                if (this.entryResults[i].id == registration.id && this.entryResults[i].updated !== registration.updated) {
                    if (this.entryResults[i].run)
                        this.entryResults[i].run.used = false;

                    Object.assign(this.entryResults[i], registration);
                    this.updateEntryInfo(this.entryResults[i]);
                }
            }
        });
    }

    registrationDeleted(data) {
        data.forEach(regUpdateInfo => {
            this.entryResults = this.entryResults.filter(x => x.id != regUpdateInfo.id);
        });
    }

    getSearchMessage() {
        if (this.loadingData)
            return "";

        if (this.searchQuery == undefined || this.searchQuery.trim().length == 0)
            return "";
        else if (this.searchResults == undefined || this.searchResults.length < 1) {
            if (this.rodeoEventFilter === 'No Filter')
                return "There are no users in NextGenRodeo by that name.";
            else
                return "There are no users entered into this rodeo by that name.";
        }

        return "";
    }

    getCompleteTeams(rodeoEvent: RodeoEvent) {
        return rodeoEvent.registrations.filter(x => x.contestantOne != null && x.contestantTwo != null).length;
    }

    getHeaderDraws(rodeoEvent: RodeoEvent) {
        return rodeoEvent.registrations.filter(x => (x.contestantTwo == null) && !x.teammateHeader).length;
    }

    getHeelerDraws(rodeoEvent: RodeoEvent) {
        return rodeoEvent.registrations.filter(x => (x.contestantTwo == null) && x.teammateHeader).length;
    }

    getEntryCount(rodeoEvent: RodeoEvent, schedule: RodeoEventSchedule) {
        return rodeoEvent.registrations.filter(x => x.scheduleIds[0] == schedule.id).length;
    }

    getEntrySecondPrefCount(rodeoEvent: RodeoEvent, schedule: RodeoEventSchedule) {
        return rodeoEvent.registrations.filter(x => x.scheduleIds.length > 1 && x.scheduleIds[1] == schedule.id).length;
    }

    getEntrySameDayCount(rodeoEvent: RodeoEvent, schedule: RodeoEventSchedule) {
        return rodeoEvent.registrations.filter(x => x.scheduleIds.length == 1 && schedule.id != x.scheduleIds[0] && !x.allPreferences && new Date(this.perfMap.get(x.scheduleIds[0]).scheduledDate).getDay() == new Date(schedule.scheduledDate).getDay() && this.perfMap.get(x.scheduleIds[0]).name.toLowerCase().indexOf('slack') != -1).length;
    }

    getFirstPrefSchedule(rodeoEvent: RodeoEvent, entry: RodeoEventRegistration) {
        return rodeoEvent.schedules.filter(y => y.id == entry.scheduleIds[0])[0];
    }

    getSecondPrefSchedule(rodeoEvent: RodeoEvent, entry: RodeoEventRegistration) {
        return rodeoEvent.schedules.filter(y => y.id == entry.scheduleIds[1])[0];
    }

    onFirstNameSearchChange(searchValue: string) {
        this.onEntrySearchChange('firstName' + searchValue);
    }

    onLastNameSearchChange(searchValue: string) {
        this.onEntrySearchChange('lastName' + searchValue);
    }

    onConfirmationSearchChange(searchValue: string) {
        this.onEntrySearchChange('confirmation' + searchValue);
    }

    onRunNumberSearchChange(searchValue: string) {
        this.onEntrySearchChange('runNumber' + searchValue);
    }

    onPayConfirmationSearchChange(searchValue: string) {
        this.onEntrySearchChange('payConfirmation' + searchValue);
    }

    onEventFilterChange(searchValue: string) {
        this.onEntrySearchChange('eventFilter' + searchValue);
    }

    onScheduleFilterChange(searchValue: string) {
        this.onEntrySearchChange('scheduleFilter' + searchValue);
    }

    onEntryStatusChange(searchValue: string) {
        this.onEntrySearchChange('entryStatus' + searchValue);
    }


    onEntrySearchChange(searchValue: string) {
        if (!this.entrySearchChangeObservable) {
            Observable.create(observer => {
                this.entrySearchChangeObservable = observer;
            }).debounceTime(300)
                .distinctUntilChanged()
                .subscribe((text) => { this.filterEntries() });
        }

        this.entrySearchChangeObservable.next(searchValue);
    }

    openUserSearch(searchEvent, entryIndex, teammateSearch) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        const entry = this.entryResults[entryIndex];
        const rodeoEvent = this.rodeo.rodeoEvents.filter(x => x.id == entry.rodeoEventId)[0];

        let popover = this.popoverController.create(SearchComponent, {
            config: {
                searchTitle: (teammateSearch ? this.runDisplayHelper.getSecondLabel(rodeoEvent, null) : this.runDisplayHelper.getFirstLabel(rodeoEvent)) + " Search",
                userSearch: true,
                addNew: true
            },
            organizations: this.organizations
        }, { cssClass: 'app-search' });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null) {
                if (data.id > 0) {
                    if (teammateSearch) {
                        entry.run.contestantTwoId = data.id;
                        entry.run.contestantTwo = data;
                    } else {
                        entry.run.contestantOneId = data.id;
                        entry.run.contestantOne = data;
                    }
                } else {

                    let accountCallBack = ((newAccount) => {
                        if (newAccount != null) {
                            if (teammateSearch) {
                                entry.run.contestantTwoId = newAccount.id;
                                entry.run.contestantTwo = newAccount;
                            } else {
                                entry.run.contestantOneId = newAccount.id;
                                entry.run.contestantOne = newAccount;
                            }
                        }
                    });

                    let entryModal = this.popoverController.create(NewMemberPage, { account: null, organizations: this.organizations, firstName: data.firstName, lastName: data.lastName, callback: accountCallBack }, { cssClass: 'page-new-member', enableBackdropDismiss: true });

                    entryModal.present();
                    entryModal.onDidDismiss((newAccount) => {
                        this.popoverActive = false;
                    });

                }
            }
        })
    }

    openHorseSearch(event, entryIndex: number) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        let entry = this.entryResults[entryIndex];

        let popover = this.popoverController.create(SearchComponent, {
            config: {
                searchTitle: "Horse Search",
                horseSearch: true,
                userSearch: true,
                addNew: true
            },
            userIds: [entry.run.contestantOneId],
            userHorses: true,
            organizations: this.organizations
        }, { cssClass: 'app-search' });

        popover.present({ ev: event });

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null) {
                if (data.id) {
                    entry.run.horseOne = (data as Horse);
                    entry.run.horseOneId = (data as Horse).id;
                } else {
                    if (this.popoverActive)
                        return;

                    this.popoverActive = true;

                    this.horseService.addHorse(entry.run.contestantOneId, data)
                        .then((data) => {
                            this.popoverActive = false;

                            if (data != null && data != undefined) {
                                entry.run.horseOne = (data as Horse);
                                entry.run.horseOneId = (data as Horse).id;
                            }
                        })
                }
            }
        });
    }

    openSecondSearch(event, entryIndex: number) {
        let entry = this.entryResults[entryIndex];
        if (entry.eventType == "TeamRoping") {
            this.openUserSearch(event, entryIndex, true);
        } else {
            this.openHorseSearch(event, entryIndex);
        }
    }

    filterEntries() {
        this.entryResults = this.rodeo.rodeoEvents.flatMap(x => x.registrations);
        
        if (this.rodeoEventFilter !== 'Any') {
            this.entryResults = this.rodeo.rodeoEvents.filter(x => x.displayName.toLocaleLowerCase() === this.rodeoEventFilter.toLocaleLowerCase())[0].registrations;
        }

        if (this.scheduleFilter !== 'Any') {
            this.entryResults = this.entryResults.filter(x =>
                this.rodeo.rodeoEvents.filter(y => y.id == x.rodeoEventId)[0].schedules.filter(y =>
                    y.name.toLowerCase() === this.scheduleFilter.toLowerCase() && x.scheduleIds.indexOf(y.id) > -1).length > 0);
        }

        if (this.firstName) {
            this.entryResults = this.entryResults.filter(x =>
                x.contestantOne.firstName.toLowerCase().indexOf(this.firstName.toLocaleLowerCase()) > -1
                || (x.contestantTwo && x.contestantTwo.firstName && x.contestantTwo.firstName.toLowerCase().indexOf(this.firstName.toLocaleLowerCase()) > -1));
        }

        if (this.lastName) {
            this.entryResults = this.entryResults.filter(x =>
                x.contestantOne.lastName.toLowerCase().indexOf(this.lastName.toLocaleLowerCase()) > -1
                || (x.contestantTwo && x.contestantTwo.lastName && x.contestantTwo.lastName.toLowerCase().indexOf(this.lastName.toLocaleLowerCase()) > -1));
        }

        if (this.confirmation) {
            this.entryResults = this.entryResults.filter(x =>
                x.confirmationCode.toLowerCase().indexOf(this.confirmation.toLocaleLowerCase()) > -1);
        }

        if (this.payConfirmation) {
            this.entryResults = this.entryResults.filter(x =>
                x.payConfirmation && x.payConfirmation.toLowerCase().indexOf(this.payConfirmation.toLocaleLowerCase()) > -1);
        }

        if (this.entryStatus == 'Placed') {
            this.entryResults = this.entryResults.filter(x => x.placed == true);
        } else if (this.entryStatus != 'Any' && this.entryStatus != 'Incomplete') {
            this.entryResults = this.entryResults.filter(x => x.status == this.entryStatus);
        }

        this.totalEntryResults = this.entryResults.length;

        if (!this.firstName && !this.runNumber && !this.lastName && !this.confirmation && !this.payConfirmation && this.scheduleFilter == 'Any' && this.rodeoEventFilter == 'Any') {
            this.sortEntries();
            this.entryResults = this.entryResults.slice(0, 225);
        }

        this._rodeo.rodeoEvents.flatMap(x => x.schedules).flatMap(x => x.runs).filter(x => x.round == 1).forEach((run) => {
            run.used = false;
        });

        this.entryResults.forEach(entry => {
            this.updateEntryInfo(entry);
        });

        if (this.runNumber) {
            this.entryResults = this.entryResults.filter(x =>
                x.run && x.run.number == this.runNumber);
        }

        this.sortEntries();
    }

    toggleNameSort() {
        if (this.nameSortAsc) {
            this.nameSortAsc = false;
            this.nameSortDesc = true;
        } else {
            this.nameSortAsc = true;
            this.nameSortDesc = false;
            this.confSortAsc = false;
            this.confSortDesc = false;
            this.positionSortAsc = false;
            this.positionSortDesc = false;
        }

        this.sortEntries();
    }

    toggleConfSort() {
        if (this.confSortAsc) {
            this.confSortAsc = false;
            this.confSortDesc = true;
        } else {
            this.nameSortAsc = false;
            this.nameSortDesc = false;
            this.confSortAsc = true;
            this.confSortDesc = false;
            this.positionSortAsc = false;
            this.positionSortDesc = false;
        }

        this.sortEntries();
    }

    togglePositionSort() {
        if (this.positionSortAsc) {
            this.positionSortAsc = false;
            this.positionSortDesc = true;
        } else {
            this.positionSortAsc = true;
            this.positionSortDesc = false;
            this.confSortAsc = false;
            this.confSortDesc = false;
            this.nameSortAsc = false;
            this.nameSortDesc = false;
        }

        this.sortEntries();
    }

    sortEntries() {
        this.entryResults = this.entryResults.sort((n1, n2) => {
            if (this.positionSortAsc || this.positionSortDesc) {
                if (n1.run || n2.run) {
                    if (!n1.run && n2.run)
                        return this.positionSortDesc ? 1 : -1;
                    else if (n1.run && !n2.run)
                        return this.positionSortDesc ? -1 : 1;

                    if (n1.run.number < n2.run.number)
                        return this.positionSortDesc ? 1 : -1;
                    else if (n1.run.number > n2.run.number)
                        return this.positionSortDesc ? -1 : 1;
                }

                if (n1.id < n2.id)
                    return -1;
                else if (n1.id > n2.id)
                    return 1;
            } else if (this.confSortAsc || this.confSortDesc) {
                if (n1.confirmationCode < n2.confirmationCode)
                    return this.confSortDesc ? 1 : -1;
                else if (n1.confirmationCode > n2.confirmationCode)
                    return this.confSortDesc ? -1 : 1;

                if (n1.id < n2.id)
                    return -1;
                else if (n1.id > n2.id)
                    return 1;
            } else if (this.nameSortAsc || this.nameSortDesc) {
                if (n1.contestantOne.firstName < n2.contestantOne.firstName)
                    return this.nameSortDesc ? 1 : -1;
                else if (n1.contestantOne.firstName > n2.contestantOne.firstName)
                    return this.nameSortDesc ? -1 : 1;

                if (n1.contestantOne.lastName < n2.contestantOne.lastName)
                    return this.nameSortDesc ? 1 : -1;
                else if (n1.contestantOne.lastName > n2.contestantOne.lastName)
                    return this.nameSortDesc ? -1 : 1;

                if (n1.id < n2.id)
                    return -1;
                else if (n1.id > n2.id)
                    return 1;
            }
        });
    }

    updateEntryInfo(entry) {
        let rodeoEvent = this.rodeo.rodeoEvents.filter(y => y.id == entry.rodeoEventId)[0];
        entry.displayName = rodeoEvent.displayName;
        entry.rodeoEventIndex = this.rodeo.rodeoEvents.indexOf(rodeoEvent);
        entry.buddyDisplay = [...entry.buddies.map(x => x.firstName + ' ' + x.lastName)];
        entry.prefs = [...entry.scheduleIds.filter(x => x != -1).map(x => this.perfMap.get(x).name)];
        let runs = this._rodeo.rodeoEvents.filter(x => x.id == entry.rodeoEventId).flatMap(x => x.schedules).flatMap(x => x.runs).filter(x => x.round == 1).filter(x => 
            x.runIdentifier == entry.runIdentifier);

        let maxRuns = 1;
        
        if (rodeoEvent.ropingFormat == 'Draw')
            maxRuns = rodeoEvent.drawAmount;
        else if (rodeoEvent.ropingFormat == 'PickAndDraw') {
            maxRuns += rodeoEvent.drawAmount;
        }

        let run = runs.filter(x => x.used == undefined || x.used == false)[0];
        entry.run = new RodeoEventRun();
        if (run && run != null) {
            if (run.turnedOut) {
                // Only show change request reason/turnoutOverride if approved or completed
                if (entry.changeRequests && entry.changeRequests.length > 0
                    && entry.changeRequests
                        .some(x => x.status == ChangeRequestStatus.ApprovedPendingPayment || x.status == ChangeRequestStatus.Completed)) {
                    entry.drawPosition = ChangeRequestHelper.getReasonAbbreviation(entry.changeRequests[0]);
                } else {
                    // else just default to turned out
                    entry.drawPosition = "TO";
                }
            } else {
                entry.drawPosition = this.perfMap.get(run.rodeoEventScheduleId).name;
            }

            Object.assign(entry.run, run);
        } else {
            entry.drawPosition = "N/A";
            entry.run = null;
        }

        if (entry.secondPrefTurnout)
            entry.prefs += ", Out";
        else
            entry.prefs.push(entry.thirdPrefTurnout ? 'Out' : 'Fill');
    }

    async viewEntryLogs(entry: any) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let rodeoEvent = this.rodeo.rodeoEvents.filter(x => x.id == entry.rodeoEventId)[0];

        let logs = await this.entryService.getEntryLogs(entry.id);

        let entryModal = this.modalCtrl.create(EntryLogsPage, { rodeoEvent: rodeoEvent, logs: logs }, { cssClass: 'page-entry-logs', enableBackdropDismiss: false });

        entryModal.present();
        entryModal.onDidDismiss((data) => {
            this.popoverActive = false;
        });
    }

    editRun(index: number, existingRun: RodeoEventRun) {
        if (!this.runChangedObservable) {
            Observable.create(observer => {
                this.runChangedObservable = observer;
            }).debounceTime(500) // wait 500ms after the last event before emitting last event
                .distinctUntilChanged() // only emit if value is different from previous value
                .subscribe((runEdit) => {
                    this.updateRun(runEdit.index, runEdit.existingRun);
                });
        }

        this.runChangedObservable.next({ index, existingRun });
    }

    updateRun(index: number, existingRun: RodeoEventRun) {
        console.log("updateRun called in entries....");
        existingRun.saving = true;

        this.updateRuns(index, [existingRun]);
    }

    updateRuns(entryIndex: number, runs: any[]) {
        let entry = this.entryResults[entryIndex];
        let rodeoEvent = this._rodeo.rodeoEvents.filter(x => x.id == entry.rodeoEventId)[0];

        this.runService.updateRuns(runs)
            .then((data) => {
                (data as RodeoEventRun[]).forEach(run => {
                    run.saving = false;
                    run.error = false;

                    let runIndex = rodeoEvent.schedules[0].runs.findIndex(x => x.id == run.id);
                    rodeoEvent.schedules[0].runs[runIndex] = run;
                });
            }, error => {
                runs.forEach((run) => {
                    run.error = true;
                    run.saving = false;
                });
            });
    }

    viewDetails(entry) {
        if (this.loadingData)
            return;

        this.loadingData = true;
        let loading = this.loadingController.create({
            content: 'Retrieving Payment Information...',
        });
        loading.present();

        this.paymentService.getPaymentDetails(this._rodeo.secretary.id, entry.payConfirmation)
            .then(data => {
                loading.dismiss();
                this.loadingData = false;

                let entryModal = this.modalCtrl.create(PaymentDetailsPage, { entry: entry, details: data }, { cssClass: 'page-payment-details', enableBackdropDismiss: false });

                entryModal.present();
                entryModal.onDidDismiss((data) => {
                    this.popoverActive = false;
                });
            }).catch(error => {
                loading.dismiss();
                this.popoverActive = false;
                this.loadingData = false;

                this.alert.showError("Payment Error", "Payment failed to process.  Please contact NextGenRodeo.");
            });
    }

    addNewRegistration() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(EventSelectPopup, {
            rodeo: this.rodeo
        }, {
            cssClass: 'page-event-select'
        });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data && data.selectedRodeoEvent) {
                this.popoverActive = true;

                let entryModal = this.modalCtrl.create(NewEntryPage, {
                    rodeo: this.rodeo,
                    rodeoEvent: data.selectedRodeoEvent,
                    organizations: this._organizations,
                    staff: true,
                    addRun: this.rodeo.drawn
                }, { cssClass: 'page-entries-new', enableBackdropDismiss: false });

                entryModal.present();
                entryModal.onDidDismiss((data) => {
                    this.popoverActive = false;

                    if (data && data.entries && data.entries > 0) {
                        data.entries.forEach(entry => {
                            this.updateEntryInfo(entry);

                            let entryResults = this.entryResults.filter(x => x.id == entry.id);

                            if (entryResults.length > 0)
                                Object.assign(entryResults[0], entry);

                            if (!this._rodeo.rodeoEvents.filter(x => x.id == entry.rodeoEventId)[0].registrations.some(x => x.id == entry.id))
                                this._rodeo.rodeoEvents.filter(x => x.id == entry.rodeoEventId)[0].registrations.push(entry);
                        });

                        this.filterEntries();
                    }
                });
            }
        })
    }

    deleteRun(index: number) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let entry = this.entryResults[index];

        let message = `Are you sure you want to remove #${entry.run.number} ${entry.run.contestantOne.firstName} ${entry.run.contestantOne.lastName}? If this is a winning run, it will also remove any points.`;

        let alert = this.alertController.create({
            title: 'Confirm Run Removal',
            message: message,
            buttons: [
                {
                    text: 'Yes',
                    handler: () => {
                        this.runService.deleteRun(entry.run.id)
                            .then(data => {
                                this.runService.addTempDeleted(entry.run.id);

                                entry.run = null;
                                this.popoverActive = false;
                            }, error => {
                                this.alert.showError("Run Removal Error", error);
                                this.popoverActive = false;
                            });
                    }
                },
                {
                    text: 'No',
                    role: 'cancel',
                    handler: () => { }
                }]
        });

        alert.present();

        alert.onDidDismiss(() => {
            this.popoverActive = false;
        })
    }

    editEntry(entry: any) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let rodeoEvent = this.rodeo.rodeoEvents.filter(x => x.id == entry.rodeoEventId)[0];

        var entryToEdit = JSON.parse(JSON.stringify(entry));
        let entryModal = this.modalCtrl.create(NewEntryPage, {
            rodeo: this.rodeo,
            rodeoEvent: rodeoEvent,
            organizations: this._organizations,
            staff: true,
            entry: entryToEdit,
            addRun: this.rodeo.drawn
        }, { cssClass: 'page-entries-new', enableBackdropDismiss: false });

        entryModal.present();
        entryModal.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data) {
                if (data.runs && data.runs.length > 0) {
                    data.runs.forEach(updatedRun => {
                        var foundRun = false;
                        for (let i = 0; i < this.rodeo.rodeoEvents.length; i++) {
                            for (let x = 0; x < this.rodeo.rodeoEvents[i].schedules.length; x++) {
                                if (this.rodeo.rodeoEvents[i].schedules[x].id != updatedRun.rodeoEventScheduleId)
                                    continue;

                                for (let y = 0; y < this.rodeo.rodeoEvents[i].schedules[x].runs.length; y++) {
                                    if (this.rodeo.rodeoEvents[i].schedules[x].runs[y].id == updatedRun.id) {
                                        Object.assign(this.rodeo.rodeoEvents[i].schedules[x].runs[y], updatedRun);
                                        this.rodeo.rodeoEvents[i].schedules[x].runs[y].used = false;
                                        foundRun = true;
                                        break;
                                    }
                                }

                                if (foundRun)
                                    break;
                            }

                            if (foundRun)
                                break;
                        }
                    });
                }

                if (data.entries && data.entries.length > 0) {
                    data.entries.forEach(updatedEntry => {
                        for (let i = 0; i < this.entryResults.length; i++) {
                            if (this.entryResults[i].id == updatedEntry.id) {
                                if (updatedEntry.run)
                                    updatedEntry.run.used = false;

                                this.updateEntryInfo(updatedEntry);
                                Object.assign(this.entryResults[i], updatedEntry);
                                break;
                            }
                        }

                        this._rodeo.rodeoEvents[this._rodeo.rodeoEvents.indexOf(rodeoEvent)].registrations.filter(x => x.id == updatedEntry.id)[0] = updatedEntry;
                    });
                }
            }
        });
    }

    removeEntry(rodeoEvent: RodeoEvent, entry: RodeoEventRegistration) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let alert = this.alertController.create({
            title: 'Confirm Entry Removal',
            message: 'Do you want to remove this entry?',
            buttons: [
                {
                    text: 'Yes',
                    handler: () => {
                        this.entryService.deleteEntry(entry.id)
                            .then(data => {
                                if (data == null || data == undefined) {
                                    this._rodeo.rodeoEvents[this._rodeo.rodeoEvents.indexOf(rodeoEvent)].registrations = this._rodeo.rodeoEvents[this._rodeo.rodeoEvents.indexOf(rodeoEvent)].registrations.filter(x => x.id != entry.id);
                                    this.toast.create({
                                        message: 'Entry was removed successfully.',
                                        duration: 1500,
                                        position: 'middle'
                                    }).present();

                                } else if ((data as any).message != null && (data as any).message != undefined) {
                                    this.alert.showError("Entry Removal Failed", (data as any).message);
                                }
                            }, error => {
                                this.alert.showError("Entry Removal Error", error);
                            });
                    }
                },
                {
                    text: 'No',
                    role: 'cancel',
                    handler: () => { }
                }]
        });

        alert.present();

        alert.onDidDismiss(() => {
            this.popoverActive = false;
        })
    }

    updatePendingRequestCount(requestCount: any) {
        this.pendingRequestCountUpdated.emit(requestCount);
    }
}




// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/entries/entries.ts